"use client";

import React from "react";
import { ThemeProvider } from "./theme-provider";
import { AuthProvider } from "./auth-context";
import { UserProvider } from "./user-context";
import { NavProvider } from "./nav-context";
import { AccessControlProvider } from "./access-control-context";

interface RootProviderProps {
  children: React.ReactNode;
}

/**
 * Root provider that combines all app providers in the correct order
 * This ensures that dependent providers are wrapped properly
 */
export function RootProvider({ children }: RootProviderProps) {
  return (
    <AuthProvider>
      <UserProvider>
        <AccessControlProvider>
          <ThemeProvider>
            <NavProvider>
              {children}
            </NavProvider>
          </ThemeProvider>
        </AccessControlProvider>
      </UserProvider>
    </AuthProvider>
  );
}
